export enum GetGasStep {
  WAITING_SIGNATURE,
  VALIDATING_TRANSACTION,
  SWAPPED,
  UNKNOWN_ERROR,
}
